import Typography from 'components/gruenland/atoms/typography';
import { useFormat } from 'helpers/hooks/useFormat';
import CartPaymentSection from './CartPaymentSection';
import { CartSummaryProps } from './types';

const CartSummary = ({
  className,
  discounts,
  onApplyDiscountCode,
  onRemoveDiscountCode,
  ...props
}: CartSummaryProps) => {
  const { formatMessage } = useFormat({ name: 'gruenland' });

  return (
    <div className={className}>
      <div className="py-4 md:py-6 lg:pb-6 lg:pt-0">
        <Typography className="md:text-[18px]">
          {formatMessage({ id: 'order.summary', defaultMessage: 'Riepilogo ordine' })}
        </Typography>
      </div>

      <CartPaymentSection
        discounts={discounts}
        onApplyDiscountCode={onApplyDiscountCode}
        onRemoveDiscountCode={onRemoveDiscountCode}
        button={props.button}
        {...props}
      />
    </div>
  );
};

export default CartSummary;
